<!-- <div class="card">
    <p-toolbar styleClass="mb-4">
        <div class="formgrid p-fluid grid col-12 ">
            <div class="field col-12 md:col-12 xl:col-4 mt-3">
                <p-floatlabel>
                    <p-datepicker appendTo="body" class="ml-2" dateFormat="dd/mm/yy" placeholder="Periodo"
                        [(ngModel)]="rangeDate" selectionMode="range" inputId="range">
                    </p-datepicker>
                    <label for="periodo">Periodo</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-3 mt-3">
                <p-floatlabel>
                    <p-dropdown appendTo="body" inputId="estacao" [filter]="true" filterLocale="pt-BR" [options]="dropDownEstacao"
                        [(ngModel)]="estacao_id">
                    </p-dropdown>
                    <label for="estacao_id">Estação</label>
                </p-floatlabel>
            </div>
            <div class="field col-12 md:col-12 xl:col-2 mt-3">
                <button pButton pRipple pTooltip="Filtrar" (click)="filtrar()" type="button" icon="pi pi-search"
                    class="p-button-rounded p-button-success"></button>
            </div>


        </div>


    </p-toolbar>

    
</div> -->

<div *ngIf="value.length > 0" class="variavel-container col-12 md:col-12 xl:col-12">

    <ng-container *ngIf="exibirCabecalhoExportacao">
        <div class="row flex variavel-header">
            <div class="col-12 md:col-12 xl:col-10">
                <h6>{{descricao_estacao}}</h6>
            </div>
        </div>

        <p-toolbar styleClass="variavel-toolbar">
            <ng-template pTemplate="right">
                <button pButton pRipple icon="pi pi-file-excel" class="p-button-rounded p-button-success mr-2"
                    (click)="exportExcel()"></button>

                <button pButton pRipple icon="pi pi-file-pdf" class="p-button-rounded p-button-warning mr-2"
                    (click)="exportPdf()"></button>
            </ng-template>
        </p-toolbar>
    </ng-container>


    <div class="variavel-table-wrapper" #tableWrapper>
        <p-table #dt [value]="value" [rows]="25" styleClass="p-datatable-gridlines"
            [paginator]="true" [globalFilterFields]="['data']" [rowsPerPageOptions]="[10,25,50]"
            [paginatorDropdownAppendTo]="'body'"
            currentPageReportTemplate="Mostrando {first} de {totalRecords} registros" [showCurrentPageReport]="true"
            [lazy]="false" [rowHover]="true" dataKey="id" [sortMode]="'single'"
            (onSort)="onSort($event)"
            [scrollable]="true" scrollHeight="flex">

        <!-- Barra de busca acima da tabela -->
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Procurar..." />
                </span>
            </div>
        </ng-template>

        <!-- Cabeçalho da tabela -->
        <ng-template pTemplate="header">
            <tr>
                <!-- Gera as colunas dinamicamente -->
                <ng-container *ngFor="let col of columns">
                    <th [pSortableColumn]="col.field === 'data' ? 'timestamp' : col.field"
                        *ngIf="col.field !== 'timestamp'">
                        {{ col.header }}
                        <ng-container *ngIf="col.field === 'data'">
                            <p-sortIcon field="timestamp"></p-sortIcon>
                        </ng-container>
                    </th>
                </ng-container>

            </tr>
        </ng-template>

        <!-- Corpo da tabela -->
        <ng-template pTemplate="body" let-ret>
            <tr>
                <!-- Preenche as colunas dinamicamente, ocultando o campo 'timestamp' -->
                <ng-container *ngFor="let col of columns">
                    <td *ngIf="col.field !== 'timestamp'">
                        <ng-container *ngIf="exibirMarcacoesEvento && temMarcacoesNaColuna(ret, col.field); else valorColunaPadrao">
                            <div class="variavel-celula-com-marcacao">
                                <span class="variavel-celula-valor">{{ ret[col.field] }}</span>
                                <span class="variavel-eventos-marcacao">
                                    <i *ngFor="let evento of getMarcacoesColuna(ret, col.field)"
                                        [class]="evento.icone"
                                        [ngStyle]="{'color': evento.cor}"
                                        [pTooltip]="evento.descricao"
                                        tooltipPosition="top"
                                        class="variavel-evento-icone"></i>
                                </span>
                            </div>
                        </ng-container>
                        <ng-template #valorColunaPadrao>
                            {{ ret[col.field] }}
                        </ng-template>
                    </td>
                </ng-container>
            </tr>
        </ng-template>

    </p-table>







</div>
